import { route } from "../../../../application/domain/routing/named-route";
import { REG_EXP_STR_FOR_UUID } from "../../../../utils/url-utils";
import { KintoneExportReportDetailPage } from "./kintone-export-report-detail/kintone-export-report-detail";
import { KintoneExportSettingCreatePage } from "./kintone-export-setting-create/kintone-export-setting-create";
import { KintoneExportSettingDetailPage } from "./kintone-export-setting-detail/kintone-export-setting-detail";
import {
  KintoneExportSettings,
  RedirectToKintoneExportSettings,
} from "./kintone-export-settings/kintone-export-settings";
export const KintoneExportR = {
  KintoneExportTop: route({
    path: "/data-transfer/kintone-export",
    component: RedirectToKintoneExportSettings,
  }),

  KintoneExportSettings: route({
    path: "/data-transfer/kintone-export/settings",
    component: KintoneExportSettings,
  }),
  KintoneExportSettingCreate: route({
    path: "/data-transfer/kintone-export/settings/create",
    component: KintoneExportSettingCreatePage,
  }),
  KintoneExportSettingDetail: route({
    path: `/data-transfer/kintone-export/settings/:kintoneExportSettingId(${REG_EXP_STR_FOR_UUID})`,
    link: (args: { kintoneExportSettingId: string }) => {
      return `/data-transfer/kintone-export/settings/${args.kintoneExportSettingId}`;
    },
    component: KintoneExportSettingDetailPage,
  }),
  KintoneExportReportDetail: route({
    path: "/data-transfer/kintone-export/settings/:kintoneExportSettingId/reports/:kintoneExportReportId",
    link: (args: {
      kintoneExportSettingId: string;
      kintoneExportReportId: string;
    }) => {
      return `/data-transfer/kintone-export/settings/${args.kintoneExportSettingId}/reports/${args.kintoneExportReportId}`;
    },
    component: KintoneExportReportDetailPage,
  }),
};
